import { render } from "./InitialAgreement.vue?vue&type=template&id=0dfea3cf"
import script from "./InitialAgreement.vue?vue&type=script&lang=js"
export * from "./InitialAgreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/InitialAgreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dfea3cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dfea3cf', __exports__)) {
    api.reload('0dfea3cf', __exports__)
  }
  
  module.hot.accept("./InitialAgreement.vue?vue&type=template&id=0dfea3cf", () => {
    api.rerender('0dfea3cf', render)
  })

}


export default __exports__